import {FmlxModal} from 'fmlx-common-ui';
import {FMLX_BUTTON} from '../../../const/FmlxComponentEnum';

const ModalNoAccess = ({open}) => {
  return (
    <FmlxModal
      open={open}
      size="md"
      title="Error Occurred"
      onCloseClick={() => {
      }}
      primaryButton={{
        show: true,
        disabled: false,
        label: 'Cancel',
        type: FMLX_BUTTON.TYPE.PRIMARY,
        variant: FMLX_BUTTON.VARIANT.CONTAIN,
        onClick: () => {
        }
      }}
      secondaryButton={{show: false}}
      tertiaryButton={{show: false}}
    >
      Sorry, you have no access to any projects for Team Assignment
    </FmlxModal>
  );
};

export default ModalNoAccess;